// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VideoPlayer__video{height:100%}.VideoPlayer__video iframe{height:100%;width:100%}.VideoPlayer__video .MarketingEmbedPlaceholder{display:flex;flex-direction:column;height:100%;justify-content:center;min-height:12rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
